/**
 * Utility functions for subdomain detection and management
 */

/**
 * Extract subdomain from the current window location
 * @returns {string|null} The subdomain or null if not found
 */
export function getSubdomain() {
  try {
    const hostname = window.location.hostname;
    console.log('Current hostname:', hostname);

    // Handle localhost and IP addresses
    if (hostname === 'localhost' || hostname.match(/^\d+\.\d+\.\d+\.\d+$/)) {
      console.log('Localhost or IP detected, no subdomain');
      return null;
    }

    // Split hostname by dots
    const parts = hostname.split('.');
    
    // Check if we have enough parts for a subdomain (subdomain.domain.tld)
    if (parts.length >= 3) {
      const subdomain = parts[0];
      console.log('Subdomain detected:', subdomain);
      return subdomain;
    }

    console.log('No subdomain detected in hostname:', hostname);
    return null;
  } catch (error) {
    console.error('Error extracting subdomain:', error);
    return null;
  }
}

/**
 * Add subdomain parameter to a URL
 * @param {string} url - The URL to modify
 * @param {string} subdomain - The subdomain to add
 * @returns {string} The modified URL with subdomain parameter
 */
export function addSubdomainParam(url, subdomain) {
  if (!subdomain) {
    return url;
  }

  try {
    const urlObj = new URL(url, window.location.origin);
    urlObj.searchParams.set('subdomain', subdomain);
    return urlObj.toString();
  } catch (error) {
    // Fallback for relative URLs
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}subdomain=${encodeURIComponent(subdomain)}`;
  }
}

/**
 * Get subdomain and cache it for the session
 */
let cachedSubdomain = null;
let subdomainCached = false;

export function getCachedSubdomain() {
  if (!subdomainCached) {
    cachedSubdomain = getSubdomain();
    subdomainCached = true;
    console.log('Cached subdomain:', cachedSubdomain);
  }
  return cachedSubdomain;
}

/**
 * Clear the cached subdomain (useful for testing)
 */
export function clearSubdomainCache() {
  cachedSubdomain = null;
  subdomainCached = false;
  console.log('Subdomain cache cleared');
}